require('features/routing');
require('features/articleSearchResultsFacets');
require('features/segment');
require('features/googleAnalytics4');
require('./routing/queryString');
require('./routing/pageUrl');
require('./components/articleSearchBoxHandler');
require('./components/headerTitleHandler');
require('./components/pagination/paginationToggle');
require('./components/pagination/paginationBar');
require('./components/pagination/paginationPageSize');
require('./components/pagination/paginationPage');
require('./components/articleCardsHandler');
require('./components/articleCardSkeletonHandler');
require('./components/mostPopularArticleCardsHandler');
require('./components/eventTracking/googleAnalytics4EventsHandler');
require('./components/eventTracking/segmentEventsHandler');
require('./handlers/hyperlinkCardHandler');
require('./handlers/breadcrumbHandler');


// this is a temporary change load listingsForYouSection in the new search result pages to avoid
// duplicate code now, we are using the same component for both pages temporarily this will be removed 
// in the future when we have the listingCardCarousel component ready for rebranding on learning center
require('../blog/components/listingsForYouSection');